import { render, staticRenderFns } from "./ChartXlsLabel.vue?vue&type=template&id=4d8d709e&scoped=true&"
import script from "./ChartXlsLabel.vue?vue&type=script&lang=js&"
export * from "./ChartXlsLabel.vue?vue&type=script&lang=js&"
import style0 from "./ChartXlsLabel.vue?vue&type=style&index=0&id=4d8d709e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d709e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
